<template>
<div class="chapter">
<div class="inner_page">
<p class="p5">Per Monica e JJ – amici diventati reali grazie alla narrativa.</p>
<p class="p6">Con un ringraziamento speciale a Maggie e Posy.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?2568ce3c